import script from "./Object1ListView.vue?vue&type=script&setup=true&lang=js"
export * from "./Object1ListView.vue?vue&type=script&setup=true&lang=js"

import "./Object1ListView.vue?vue&type=style&index=0&id=6c7869c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7869c6"]])

export default __exports__